import { format } from 'date-fns/format';
import { parseISO } from 'date-fns/parseISO';

export const getOwnerText = (ownerName: string, dueDate?: string) => {
    if (!dueDate) {
        return ownerName;
    }
    const formatedDueDate = format(parseISO(dueDate), 'dd.MM.yyyy');
    const ownerText = `${ownerName} собирает до ${formatedDueDate}`;

    return ownerText;
};
